module.exports = __webpack_public_path__ + "media/images/cover/roof-32bca2a45ec7fd8f73018ddd2bfcd1a3.jpg";